import React, { useEffect, useState } from "react";
import NotificationAPI from "../../api/notification";
import { useNavigate } from "react-router-dom";

const Notification = ({ user, data, setData }) => {
  const navigate = useNavigate();
  const readNotification = async (elem) => {
    if (elem?.read == false) {
      let res = await NotificationAPI.readNotification(elem?._id);
      if (res.status == 200) {
        let arr = data?.map((item) =>
          item._id == elem?._id ? res.data : item
        );
        setData(arr);
      }
      if (res.data.url) {
        window.location.href = `${process.env.REACT_APP_FRONTEND_URL}${res.data.url}`;
      }
    } else if (elem?.url) {
      window.location.href = `${process.env.REACT_APP_FRONTEND_URL}${elem.url}`;
    }
  };

  const clearAllNotification = async () => {
    let res = await NotificationAPI.clearAllNotifications(user?._id);
    if (res.status == 200) {
      setData([]);
    }
  };

  return (
    <div className="notification_main">
      {data?.length == 0 ? (
        <h2 style={{ textAlign: "center", margin: "2rem 0rem 0rem 0rem" }}>
          No Notifications
        </h2>
      ) : (
        <div>
          <div className="notify-section">
            {data?.map((elem) => (
              <div
                className={elem.read == true ? "notify" : "active-notify"}
                onClick={() => {
                  readNotification(elem);
                }}
              >
                <div className="title">{elem?.title}</div>
                <div className="text">{elem?.text}</div>
              </div>
            ))}
          </div>
          <div className="clearAll" onClick={clearAllNotification}>
            Clear All
          </div>
        </div>
      )}
    </div>
  );
};

export default Notification;
